'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _prefetch = require('chemist/dist/helpers/prefetch');

var _prefetch2 = _interopRequireDefault(_prefetch);

var _chemist = require('chemist');

var _lodash = require('lodash');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _redirectable = require('../../helpers/redirectable');

var _redirectable2 = _interopRequireDefault(_redirectable);

var _order = require('../../actions/order');

var _loading = require('../../actions/loading');

var _OrderSummary = require('../../components/OrderSummary');

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _ExternalLink = require('../../components/ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _localisedPaths = require('../../helpers/localisedPaths');

var _resetCookies = require('../../helpers/resetCookies');

var _resetCookies2 = _interopRequireDefault(_resetCookies);

var _FormInput = require('../../components/FormInput');

var _bazaarvoice = require('../../helpers/bazaarvoice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderShowPage = (_dec = (0, _prefetch2.default)(function (_ref) {
  var store = _ref.store,
      params = _ref.params;

  if (params.view === 'view') {
    var userLoggedIn = _reactCookie2.default.load('sessionToken');
    if (!userLoggedIn) return null;

    return store.dispatch((0, _order.orderUserFetch)(params.id));
  }

  if (_reactCookie2.default.load('hasOrder')) {
    return store.dispatch((0, _order.orderFetch)('complete'));
  }

  return null;
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { order: state.order, error: state.error };
}), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactI18next.translate)(), _dec5 = (0, _redirectable2.default)(), _dec6 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = function (_React$Component) {
  (0, _inherits3.default)(OrderShowPage, _React$Component);

  function OrderShowPage() {
    (0, _classCallCheck3.default)(this, OrderShowPage);
    return (0, _possibleConstructorReturn3.default)(this, (OrderShowPage.__proto__ || (0, _getPrototypeOf2.default)(OrderShowPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrderShowPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ redirecting: !this.props.order.number });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.postCompleteVisit()) {
        (0, _resetCookies2.default)();
      }

      if (!this.props.order.number) {
        this.props.localisedRedirect('/cart');
      }

      this.trackBazaarvoiceTransaction();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _order.orderClose)());
    }
  }, {
    key: 'addressValues',
    value: function addressValues(address) {
      var fields = (0, _lodash.compact)([address.fullName, [address.address1, address.houseNumber, address.houseNumberAddition].filter(function (s) {
        return s && s.length;
      }).join(' '), address.address2, address.city, address.stateName, address.zipcode, address.phone]);

      return fields;
    }
  }, {
    key: 'paymentMethodName',
    value: function paymentMethodName() {
      var completed = (0, _lodash.find)(this.props.order.payments, { state: 'completed' });
      var payment = completed || (0, _lodash.last)(this.props.order.payments);

      return payment && payment.paymentMethod && payment.paymentMethod.name;
    }
  }, {
    key: 'postCompleteVisit',
    value: function postCompleteVisit() {
      return this.props.params.view === 'view';
    }
  }, {
    key: 'paintersCompleteMessage',
    value: function paintersCompleteMessage() {
      var _props = this.props,
          t = _props.t,
          order = _props.order,
          lng = _props.params.lng,
          config = _props.config;
      var theme = config.theme,
          store = config.store;
      var storeCode = store.storeCode;


      var isExceptionStore = ['ebeexp', 'enlexp'].includes(storeCode);

      return _react2.default.createElement(
        'div',
        { styleName: 'o-success-message-container' },
        _react2.default.createElement(
          'div',
          { styleName: 'o-success-message o-success-message-painters' },
          _react2.default.createElement(
            'p',
            { styleName: 'orderCompleteTitle' },
            t('spree.thank_you_for_your_purchase'),
            '. ',
            t('spree.order_placed_successfully')
          ),
          _react2.default.createElement(
            'p',
            { className: 't-text t-p', styleName: 'm-thank-you__sub-title' },
            _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'spree.your_order_number_is', number: order.number }),
            ',\xA0',
            t('spree.email_you_confirmation')
          ),
          _react2.default.createElement(
            'p',
            { className: 't-text t-p', styleName: 'm-thank-you__sub-title' },
            t('spree.confirmation_additional_notification')
          ),
          this.renderDeliveryNotification(),
          theme === 'painters' || isExceptionStore ? _react2.default.createElement(
            _FormInput.ButtonLink,
            { url: '/' + lng + '/shopping-list' },
            t('spree.to_homepage')
          ) : _react2.default.createElement(
            _FormInput.ButtonLink,
            { url: '/' },
            t('spree.to_homepage')
          )
        )
      );
    }
  }, {
    key: 'trackBazaarvoiceTransaction',
    value: function trackBazaarvoiceTransaction() {
      var enabled = this.props.config.store.bazaarvoiceTracking.enabled;


      if (enabled) {
        var order = this.props.order;

        var transaction = (0, _bazaarvoice.orderToTransaction)(order);
        window.bvCallback = function (BV) {
          BV.pixel.trackTransaction(transaction);
        };
      }
    }
  }, {
    key: 'renderDeliveryNotification',
    value: function renderDeliveryNotification() {
      if (this.props.config.store.code === 'eesbru') {
        return _react2.default.createElement(
          'p',
          { className: 't-text t-p', styleName: 'm-thank-you__sub-title' },
          'Puedes seguir el estado de tu env\xEDo en ',
          _react2.default.createElement(
            'a',
            {
              href: 'https://www.correos.es/es/es/herramientas/localizador/envios',
              style: {
                color: '#333',
                'text-decoration': 'underline',
                margin: '0px',
                padding: '0px',
                'font-size': '14px'
              },
              rel: 'noopener noreferrer',
              target: '_blank'
            },
            'la web de Correos sigue tu env\xEDo'
          ),
          '.'
        );
      }

      return '';
    }
  }, {
    key: 'renderAddress',
    value: function renderAddress(title, address) {
      var addressContent = (0, _lodash.map)(this.addressValues(address), this.renderAddressValue, this);
      return this.renderSummaryBox(title, addressContent);
    }
  }, {
    key: 'renderAddressValue',
    value: function renderAddressValue(value) {
      var displayValue = value === 'Collection Point' ? 'CollectPlus ' + value : value;
      return _react2.default.createElement(
        'div',
        null,
        displayValue
      );
    }
  }, {
    key: 'renderSummaryBox',
    value: function renderSummaryBox(title, content) {
      return _react2.default.createElement(
        'div',
        { styleName: 'm-summary-box' },
        _react2.default.createElement(
          'h3',
          { className: 't-title t-h4', styleName: 'm-summary-box__title' },
          title
        ),
        _react2.default.createElement(
          'p',
          {
            styleName: 'm-summary-box__content m-summary-box__content--steps',
            className: 't-text'
          },
          content
        )
      );
    }
  }, {
    key: 'renderEmailProviderWarning',
    value: function renderEmailProviderWarning() {
      var config = this.props.config;
      var store = config.store;
      var storeCode = store.code;


      var isWarningStore = ['eukdlx', 'eukher'].includes(storeCode);

      if (isWarningStore) {
        return _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'p',
            { styleName: 'emailProviderWarning' },
            'We\u2019re currently experiencing an issue with our email sender provider that is preventing certain email domains from receiving order confirmation emails or incorrectly allocating it into a junk folder. This has no impact on the processing & delivery of your order. If you haven\u2019t received your order confirmation email within 24 hours of placing your order and would like a copy of this, please call 0333 222 7070 or email duluxcustomerservices@akzonobel.com who can support.'
          )
        );
      }

      return '';
    }
  }, {
    key: 'renderCompleteMessage',
    value: function renderCompleteMessage() {
      if (this.postCompleteVisit()) {
        return '';
      }

      return this.paintersCompleteMessage();
    }
  }, {
    key: 'renderBazaarvoiceTracking',
    value: function renderBazaarvoiceTracking() {
      var _props$config$store$b = this.props.config.store.bazaarvoiceTracking,
          enabled = _props$config$store$b.enabled,
          loader = _props$config$store$b.loader;


      if (!enabled) {
        return '';
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          script: [{
            type: 'text/javascript',
            src: loader
          }]
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.redirecting) {
        this.props.dispatch((0, _loading.setLoading)());
        return null;
      }

      var _props2 = this.props,
          t = _props2.t,
          order = _props2.order;
      var shipAddress = order.shipAddress,
          billAddress = order.billAddress;

      var paymentMethod = this.paymentMethodName();
      var lng = this.props.params.lng;

      return _react2.default.createElement(
        'div',
        null,
        this.renderEmailProviderWarning(),
        this.renderCompleteMessage(),
        this.renderBazaarvoiceTracking(),
        _react2.default.createElement(
          'div',
          { className: 'container container-page' },
          _react2.default.createElement(
            'div',
            { styleName: 'm-order-detail' },
            _react2.default.createElement(
              'div',
              { styleName: 'm-order-detail__summary' },
              _react2.default.createElement(
                'div',
                { styleName: 'm-summary-box m-summary-box--summary' },
                _react2.default.createElement(_OrderSummary2.default, { order: order, orderSummaryVisible: true, orderCompletePage: true })
              )
            ),
            (shipAddress || billAddress || paymentMethod) && _react2.default.createElement(
              'div',
              { styleName: 'm-order-detail__information' },
              shipAddress && this.renderAddress(t('spree.shipping_address'), shipAddress),
              billAddress && this.renderAddress(t('spree.billing_address'), billAddress)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'formActions' },
            _react2.default.createElement(
              'div',
              { styleName: 'a-continueShopping' },
              _react2.default.createElement(_ExternalLink2.default, {
                href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'productsPath', lng),
                text: t('spree.continue_shopping')
              })
            )
          )
        )
      );
    }
  }]);
  return OrderShowPage;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class) || _class);
exports.default = OrderShowPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/OrderShowPage/index.js
// module id = 2513
// module chunks = 0